/*Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬
 Ã°Å¸Å’Â Project: Ring2All Platform
 Ã°Å¸Â§â€˜Ã¢â‚¬ÂÃ°Å¸â€™Â» Author: Rodrigo Cuadra
 Ã°Å¸ÂÂ¢ Company: Ring2All LLC
 Ã°Å¸â€œâ€ž File: hooks/useCallbackRulesList.tsx
 Ã°Å¸â€”â€œÃ¯Â¸Â Created: 2025-01-15
 Ã°Å¸Â§Â© Description:
    Custom hook for managing the Callback Rules list.
Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬*/

import { useCallback, useMemo, useEffect } from 'react';
import { useI18n } from '../../../hooks/useI18n';
import { useNotifications } from '../../../contexts/NotificationContext';
import { useDataGrid } from '../../../hooks/useDataGrid';
import { fetchCallbackRules } from '../api/callbackRulesApi';
import type { CallbackRule } from '../types';

interface UseCallbackRulesListOptions {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialColumns?: any[];
  initialSortBy?: string;
  initialSortOrder?: 'asc' | 'desc';
  initialLimit?: number;
  domainId?: number;
}

export function useCallbackRulesList({
  initialColumns = [],
  initialSortBy = 'name',
  initialSortOrder = 'asc',
  initialLimit = 10,
  domainId
}: UseCallbackRulesListOptions = {}) {
  const { t } = useI18n();
  const { showError } = useNotifications();

  const fetchData = useCallback(
    async (params: {
      page: number;
      limit: number;
      sortBy: string;
      sortOrder: 'asc' | 'desc';
      search?: string;
    }) => {
      try {
        const result = await fetchCallbackRules({
          page: params.page,
          limit: params.limit,
          sortBy: params.sortBy,
          sortOrder: params.sortOrder,
          search: params.search,
          domainId
        });

        // Map backend snake_case to frontend camelCase
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const mappedData = result.data.map((item: any) => ({
          id: item.id,
          uuid: item.uuid,
          domainId: item.domain_id ?? item.domainId,
          name: item.name,
          callbackNumber: item.callbackNumber || item.callback_number || null,
          context: item.context || '',
          destinationModule: item.destinationModule || item.destination_module || '',
          destinationValue: item.destinationValue || item.destination_value || '',
          settings: item.settings,
          enabled: item.enabled ?? true,
          createdAt: item.created_at || item.createdAt,
          createdBy: item.created_by ?? item.createdBy,
          updatedAt: item.updated_at ?? item.updatedAt,
          updatedBy: item.updated_by ?? item.updatedBy
        }));

        return {
          data: mappedData,
          pagination: result.pagination
        };
      } catch (error) {
        const message = error instanceof Error ? error.message : t('callbackRules:messages.loadError');
        showError(message);
        throw error;
      }
    },
    [showError, t, domainId]
  );

  const availableColumns = useMemo(() => {
    if (initialColumns.length > 0) {
      return initialColumns;
    }

    return [
      {
        key: 'name',
        label: t('callbackRules:columns.name'),
        visible: true,
        sortable: true
      },
      {
        key: 'callbackNumber',
        label: t('callbackRules:columns.callbackNumber'),
        visible: true,
        sortable: false,
        render: (_value: unknown, item: CallbackRule) => (
          <span className="font-mono text-sm">
            {(item as any).callbackNumber
              ? (item as any).callbackNumber
              : <span className="text-slate-400 dark:text-slate-500 italic text-xs">{t('callbackRules:columns.callbackNumberEmpty')}</span>
            }
          </span>
        )
      },
      {
        key: 'destination',
        label: t('callbackRules:columns.destination'),
        visible: true,
        sortable: false,
        render: (_value: unknown, item: CallbackRule) => {
          const mod = (item as any).destinationModule || '';
          const val = (item as any).destinationValue || '';
          return (
            <span className="text-sm">
              {mod && val ? <><span className="capitalize text-slate-500 dark:text-slate-400 text-xs">{mod}:</span> {val}</> : '—'}
            </span>
          );
        }
      },
      {
        key: 'enabled',
        label: t('callbackRules:columns.enabled'),
        visible: true,
        sortable: true,
        render: (_value: unknown, item: CallbackRule) => (
          <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${item?.enabled
              ? 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400'
              : 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400'
            }`}>
            {item?.enabled ? t('common:enabled') : t('common:disabled')}
          </span>
        )
      },
      { key: 'actions', label: t('callbackRules:columns.actions'), visible: true, sortable: false }
    ];
  }, [t, initialColumns]);

  const dataGrid = useDataGrid({
    fetchData,
    initialColumns: availableColumns,
    initialSortBy,
    initialSortOrder,
    initialLimit,
    moduleName: 'callback-rules'
  });

  // Refresh data when domainId changes
  useEffect(() => {
    if (domainId !== undefined) {
      dataGrid.refresh();
    }
  }, [domainId]);

  return dataGrid;
}

